import { Geometry } from '@turf/turf';
import * as _ from 'lodash';

export class Garage {
    code: string;
    id: number;
    description: string;
    hastusRegionCode: string;
    trafficAreaName: string;
    trafficAreaId: number;
    geoJson: any;
    geo: Geometry;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (this.geoJson) {
            this.updateGeoJson(this.geoJson);
        }
    }

    public updateGeoJson(geoJson: any) {
        this.geoJson = geoJson;
        try {
            this.geo = JSON.parse(geoJson);
        } catch (error) {
            console.log(`could not parse geoJson JSON for garage: ${this.description}`);
        }
    }
}
